import { useCallback } from 'react';
import { toast } from "react-toastify";


// Custom Toast Components
const SuccessToast = ({ message }) => (
  <div className="custom-toast-content">
    <div className="toast-icon-wrapper success">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </div>
    <span className="toast-text">{message}</span>
  </div>
);

const ErrorToast = ({ message }) => (
  <div className="custom-toast-content">
    <div className="toast-icon-wrapper error">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </div>
    <span className="toast-text">{message}</span>
  </div>
);

const useToastAssist = () => {
 
  const toastError = useCallback((msg) => {
    toast.dismiss();
    toast(<ErrorToast message={msg} />, {
      position: "top-center",
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: false,
      autoClose: 3800,
      className: 'toast-error-custom',
      progressClassName: 'toast-error-progress',
      style: {
        backgroundColor: "rgba(19, 22, 36, 1)",
        borderRadius: "12px",
        padding: "0",
        minWidth: "auto",   
        width: "auto",        
        maxWidth: "90vw"
      },
    });
  }, []); 

  const toastSuccess = useCallback((msg) => {
    toast.dismiss();
    toast(<SuccessToast message={msg} />, {
      position: "top-center",
      hideProgressBar: false,
      pauseOnHover: true,
      draggable: false,
      autoClose: 3000,
      className: 'toast-success-custom',
      progressClassName: 'toast-success-progress',
      style: {
        backgroundColor: "rgba(19, 22, 36, 1)",
        borderRadius: "12px",
        padding: "0",
         minWidth: "auto",   
        width: "auto",        
        maxWidth: "90vw"
      },
    });
  }, []);  

  return { toastSuccess, toastError };
};

export default useToastAssist;
